module.exports = __webpack_public_path__ + "static/media/IMG_20180203_103153.5b61e734.jpg";